module.exports = __webpack_public_path__ + "img/1x.3d601ed.jpg";